var interactiveMap = {};

interactiveMap.init = function() {

	// on region click:
	$( '#region1, #region2, #region3, #region4, #region5, #region6' ).on( 'click', function( e ) {
		e.preventDefault();
		const $region = $( this ),
			label = $region.data( 'region' ),
			$regionNews = $( '.js-map-news[data-region="' + label + '"]' );
		if ( !$region.hasClass( 'is-active') ) {
			$region.addClass( 'is-active' ).siblings( 'path, polygon' ).removeClass( 'is-active' );
			$( '.js-map-news' ).removeClass(' is-active' );
			setTimeout( function() {
				$regionNews.addClass( 'is-active' );
			}, 300 );
		}
	} );

	// Dronten standaard actief:
	$('#region2').click();

};

export { interactiveMap };
